var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.sightlineComb,
          expression: "sightlineComb"
        }
      ]
    },
    [
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-point" }),
        _c("label", { staticClass: "sm-function-module-sub-section-setting" }, [
          _vm._v("观察者信息")
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("div", [
            _c("div", { staticClass: "sm-half" }, [
              _c(
                "label",
                { staticClass: "sm-function-module-sub-section-caption" },
                [_vm._v("经度(°)")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.viewlongitude,
                    expression: "viewlongitude"
                  }
                ],
                staticClass: "sm-input-right",
                attrs: { type: "text" },
                domProps: { value: _vm.viewlongitude },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.viewlongitude = $event.target.value
                  }
                }
              })
            ]),
            _c("div", { staticClass: "sm-half" }, [
              _c(
                "label",
                {
                  staticClass: "sm-function-module-sub-section-caption",
                  staticStyle: { "margin-left": "20px" }
                },
                [_vm._v("纬度(°)")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.viewlatitude,
                    expression: "viewlatitude"
                  }
                ],
                staticClass: "sm-input-right",
                attrs: { type: "text" },
                domProps: { value: _vm.viewlatitude },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.viewlatitude = $event.target.value
                  }
                }
              })
            ])
          ]),
          _c("div", [
            _c("div", { staticClass: "sm-half" }, [
              _c(
                "label",
                { staticClass: "sm-function-module-sub-section-caption" },
                [_vm._v("高程(m)")]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.viewheight,
                    expression: "viewheight"
                  }
                ],
                staticClass: "sm-input-right",
                attrs: { type: "text" },
                domProps: { value: _vm.viewheight },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.viewheight = $event.target.value
                  }
                }
              })
            ])
          ])
        ]),
        _c("div", { staticClass: "sm-point" }),
        _c("label", { staticClass: "sm-function-module-sub-section-setting" }, [
          _vm._v("参数设置")
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c(
            "div",
            [
              _c(
                "label",
                { staticClass: "sm-function-module-sub-section-caption" },
                [_vm._v("可见区域颜色")]
              ),
              _c("ColorPicker", {
                staticClass: "sm-colorpicker",
                attrs: { alpha: "" },
                model: {
                  value: _vm.visibleColor,
                  callback: function($$v) {
                    _vm.visibleColor = $$v
                  },
                  expression: "visibleColor"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "label",
                { staticClass: "sm-function-module-sub-section-caption" },
                [_vm._v("不可视颜色")]
              ),
              _c("ColorPicker", {
                staticClass: "sm-colorpicker",
                attrs: { alpha: "" },
                model: {
                  value: _vm.hiddenColor,
                  callback: function($$v) {
                    _vm.hiddenColor = $$v
                  },
                  expression: "hiddenColor"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "label",
                { staticClass: "sm-function-module-sub-section-caption" },
                [_vm._v("障碍物高亮颜色")]
              ),
              _c("ColorPicker", {
                staticClass: "sm-colorpicker",
                attrs: { alpha: "" },
                model: {
                  value: _vm.highlightBarrierColor,
                  callback: function($$v) {
                    _vm.highlightBarrierColor = $$v
                  },
                  expression: "highlightBarrierColor"
                }
              })
            ],
            1
          ),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.highlightBarrier,
                  expression: "highlightBarrier"
                }
              ],
              attrs: { type: "checkbox", checked: "" },
              domProps: {
                checked: Array.isArray(_vm.highlightBarrier)
                  ? _vm._i(_vm.highlightBarrier, null) > -1
                  : _vm.highlightBarrier
              },
              on: {
                change: function($event) {
                  var $$a = _vm.highlightBarrier,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.highlightBarrier = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.highlightBarrier = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.highlightBarrier = $$c
                  }
                }
              }
            }),
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("高亮显示障碍物")]
            )
          ])
        ]),
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.analysis }
            },
            [_vm._v(" 分析 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clear }
            },
            [_vm._v("清除")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }